// extracted by mini-css-extract-plugin
export default {"infoBox":"_2rrLp3_reUqdubiX9Sz2Jz","icon":"PDaBuFu4iCzH1TZBEuBSb"};